import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGame } from '../state/GameProvider';

export function Home() {
  const { createRoom, joinRoom } = useGame();
  const nav = useNavigate();
  const [username, setUsername] = useState('');
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);

  const onCreate = async () => {
    if (!username.trim()) return;
    setBusy(true);
    const c = await createRoom(username.trim());
    setBusy(false);
    if (c) nav(`/lobby/${c}`);
  };

  const onJoin = () => {
    if (!username.trim() || !code.trim()) return;
    joinRoom(code.trim().toUpperCase(), username.trim());
    nav(`/lobby/${code.trim().toUpperCase()}`);
  };

  return (
    <main className="min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <header className="mb-8 text-center">
          <h1 className="text-5xl font-bold tracking-tight">
            Share <span className="text-accent">Paint</span>
          </h1>
          <p className="mt-2 text-white/60">Dibujo colaborativo por turnos · Cadáver exquisito</p>
        </header>

        <section className="card space-y-4">
          <label className="block">
            <span className="text-sm text-white/60">Tu nombre</span>
            <input
              className="input mt-1"
              maxLength={20}
              placeholder="Ej: Picachu"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </label>

          <button disabled={!username.trim() || busy} onClick={onCreate} className="btn-primary w-full">
            {busy ? 'Creando…' : 'Crear nueva sala'}
          </button>

          <div className="flex items-center gap-3 text-white/30 text-xs">
            <div className="flex-1 h-px bg-white/10" /> o ÚNETE <div className="flex-1 h-px bg-white/10" />
          </div>

          <label className="block">
            <span className="text-sm text-white/60">Código de sala</span>
            <input
              className="input mt-1 uppercase tracking-widest text-center text-lg"
              maxLength={6}
              placeholder="ABC123"
              value={code}
              onChange={(e) => setCode(e.target.value.toUpperCase())}
            />
          </label>

          <button disabled={!username.trim() || code.length !== 6} onClick={onJoin} className="btn-ghost w-full">
            Unirme
          </button>
        </section>

        <p className="mt-6 text-center text-xs text-white/40">
          Al crear o unirte, se te asigna un color para la fase de revelación.
        </p>
      </div>
    </main>
  );
}
